// @flow

import { toastr } from 'react-redux-toastr';
import { makeApiCall } from '../../../../../services/apiService/apiService';

export const createPrqV3Actions = {
  GET_PICKUP_CONFIG: 'GET_PICKUP_CONFIG',
  CREATE_PRQ: 'CREATE_PRQ',
  GET_TIME_SLOTS: 'GET_TIME_SLOTS_APPOINTMENT',
  NEW_PICKUP: 'NEW_PICKUP'
};

export const pickupAction = (actionType: string, load: Object) => ({
  type: actionType,
  payload: load
});

export const newPickup = () => (dispatch: Function) => {
  dispatch(
    pickupAction(createPrqV3Actions.NEW_PICKUP, {
      pickupData: null,
      fetchingPickupDetails: false,
      fetchedPickupDetails: false
    })
  );
};

export const getPickupConfig = () => (dispatch: Function) => {
  dispatch(
    pickupAction({
      pickupConfig: null,
      fetchingPickupConfig: true,
      fetchedPickupConfig: false
    })
  );
  const requestObj = {
    baseUrl: 'zoomApiUrl',
    apiEndPoint: 'getpickupConfig',
    successCb: res => {
      if (res.status === 'SUCCESS') {
        dispatch(
          pickupAction(createPrqV3Actions.GET_PICKUP_CONFIG, {
            pickupConfig: res.payload,
            fetchingPickupConfig: false,
            fetchedPickupConfig: true
          })
        );
      } else if (res.status === 'FAILURE') {
        // eslint-disable-next-line
        console.log('Failure to getpickupConfig ', res);
        dispatch(
          pickupAction(createPrqV3Actions.GET_PICKUP_CONFIG, {
            pickupConfig: null,
            fetchingPickupConfig: false,
            fetchedPickupConfig: true
          })
        );
      }
    },
    failureCb: res => {
      // eslint-disable-next-line
      console.log('Failure to getpickupConfig ', res);
      dispatch(
        pickupAction(createPrqV3Actions.GET_PICKUP_CONFIG, {
          pickupConfig: null,
          fetchingPickupConfig: false,
          fetchedPickupConfig: true
        })
      );
    },
    catchCb: res => {
      // eslint-disable-next-line
      console.log('Exception while getpickupConfig ', res);
      dispatch(
        pickupAction(createPrqV3Actions.GET_PICKUP_CONFIG, {
          pickupConfig: null,
          fetchingPickupConfig: false,
          fetchedPickupConfig: true
        })
      );
    }
  };
  return makeApiCall(requestObj);
};

export const getTimeSlots = (pickupDateTimeStamp: number) => (
  dispatch: Function
) => {
  const requestObj = {
    baseUrl: 'zoomApiUrl',
    apiEndPoint: 'getTimeSlots',
    replaceParamsArr: [{ key: 'pickupdate', val: pickupDateTimeStamp }],
    successCb: res => {
      if (res.status === 'SUCCESS') {
        dispatch(
          pickupAction(createPrqV3Actions.GET_TIME_SLOTS, {
            timeSlotList: res.payload
          })
        );
      } else if (res.status === 'FAILURE') {
        dispatch(
          pickupAction(createPrqV3Actions.GET_TIME_SLOTS, {
            timeSlotList: []
          })
        );
      }
    },
    failureCb: () => {
      dispatch(
        pickupAction(createPrqV3Actions.GET_TIME_SLOTS, {
          timeSlotList: []
        })
      );
    },
    catchCb: () => {
      dispatch(
        pickupAction(createPrqV3Actions.GET_TIME_SLOTS, {
          timeSlotList: []
        })
      );
    }
  };
  return makeApiCall(requestObj);
};

export const createPickupCall = (obj: Object) => (dispatch: Function) => {
  dispatch(
    pickupAction(createPrqV3Actions.CREATE_PRQ, {
      pickupData: null,
      fetchingPickupDetails: true,
      fetchedPickupDetails: false,
      postCallFailureMsg: null
    })
  );
  const requestObj = {
    baseUrl: 'zoomApiUrl',
    apiEndPoint: 'pickup',
    method: 'POST',
    data: obj,
    successCb: res => {
      if (res.status === 'SUCCESS' && res.payload && res.payload.id) {
        dispatch(
          pickupAction(createPrqV3Actions.CREATE_PRQ, {
            pickupData: res.payload,
            fetchingPickupDetails: false,
            fetchedPickupDetails: true,
            postCallFailureMsg: null
          })
        );
        toastr.success(
          'Success',
          !res.payload.isAnotherPrqMergedWithThisPickup
            ? 'Pickup created successfully'
            : res.payload.remarks,
          { timeOut: 0 }
        );
      } else {
        dispatch(
          pickupAction(createPrqV3Actions.CREATE_PRQ, {
            pickupData: null,
            fetchingPickupDetails: false,
            fetchedPickupDetails: true,
            postCallFailureMsg:
              res.errorMessage || 'Could not create pickup. Please try again'
          })
        );
      }
    },
    failureCb: () => {
      dispatch(
        pickupAction(createPrqV3Actions.CREATE_PRQ, {
          pickupData: null,
          fetchingPickupDetails: false,
          fetchedPickupDetails: true,
          postCallFailureMsg: 'Could not create pickup. Please try again'
        })
      );
    },
    catchCb: () => {
      dispatch(
        pickupAction(createPrqV3Actions.CREATE_PRQ, {
          pickupData: null,
          fetchingPickupDetails: false,
          fetchedPickupDetails: true,
          postCallFailureMsg: 'Could not create pickup. Please try again'
        })
      );
    }
  };
  return makeApiCall(requestObj);
};
